export default __webpack_public_path__ + "823ea3cf1a23aabd4e7ba6c355e07658.png";